import React from "react";
import styled from "styled-components";
import { read_timeline_value_label } from "../../../utils/timeline/timeline_formatting";
import { read_sales_session_change } from "./sales_session_view";

const TimelineSalesChange = styled.div`
    display: grid;
    grid-template-columns: ${p => p.$compact ? "minmax(0, 1fr)" : "minmax(8rem, 12rem) minmax(0, 1fr)"};
    gap: 0.6rem;
    align-items: center;

    > p {
        color: ${p => p.theme.color};
        font-weight: 600;
        overflow-wrap: anywhere;
    }
`;

const TimelineSalesChangeFlow = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
    min-width: 0;
`;

const TimelineSalesPreviousValue = styled.p`
    color: var(--greyDark) !important;
    overflow-wrap: anywhere;
`;

const TimelineSalesCurrentValue = styled.p`
    color: ${p => p.theme.color} !important;
    font-weight: 600;
    overflow-wrap: anywhere;
`;

const TimelineSalesChangeArrow = styled.span`
    color: ${p => p.theme.mid};
`;

// Displays one field edit retained inside a completed Sales session.
export const Timeline_Sales_Session_Change = (props) => {
    const change = read_sales_session_change(props.change);
    const previousValue = read_timeline_value_label(change.from, "");
    const isBrandChange = ["brand", "brandname", "internalname"].includes(`${change.field || ""}`.trim().toLowerCase());

    return (
        <TimelineSalesChange $compact={isBrandChange}>
            {!isBrandChange && <p>{props.t(change.field || "Field")}</p>}
            <TimelineSalesChangeFlow>
                {previousValue && <TimelineSalesPreviousValue>{previousValue}</TimelineSalesPreviousValue>}
                {previousValue && <TimelineSalesChangeArrow aria-hidden="true">→</TimelineSalesChangeArrow>}
                <TimelineSalesCurrentValue>{read_timeline_value_label(change.to)}</TimelineSalesCurrentValue>
            </TimelineSalesChangeFlow>
        </TimelineSalesChange>
    );
};
